module.exports = __webpack_public_path__ + "static/img/face15.736ec0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face15.jpg
// module id = 2lP8
// module chunks = 0